<template>
  <!-- 註冊編號和車身編號彈窗 -->
  <el-dialog
    :title="$t('message.DataRegistration.Vehicle.registrationNo')"
    :visible="true"
    :close-on-click-modal="false"
    width="500px"
    :before-close="handleClose"
  >
    <el-form ref="myForm" :model="registNoForm" :rules="registNoRules" hide-required-asterisk>
      <el-form-item
        :label="$t('message.DataRegistration.Vehicle.identificationNo_plh2')"
        prop="registrationNo"
      >
        <el-input v-model="registNoForm.registrationNo" maxlength="8"></el-input>
      </el-form-item>
      <span
        class="registrationNo_tips"
      >{{$t('message.DataRegistration.Vehicle.registrationNo_tips')}}</span>
      <el-form-item
        :label="$t('message.DataRegistration.Vehicle.identificationNo_last4_plh')"
        prop="identificationNo"
      >
        <el-input v-model="registNoForm.identificationNo" maxlength="4" placeholder></el-input>
      </el-form-item>
      <div
        class="identificationNo_tips"
      >{{$t('message.DataRegistration.Vehicle.identificationNo_tips')}}</div>
      <img src="../assets/livrete.gif" width="100%" />
      <div class="identificationNo_mark">
        {{$t('message.DataRegistration.Vehicle.identificationNo_mark1')}}
        <br />
        {{$t('message.DataRegistration.Vehicle.identificationNo_mark2')}}
        <br />
        {{$t('message.DataRegistration.Vehicle.identificationNo_mark3')}}
      </div>
      <el-form-item :label="$t('message.captcha')" prop="captcha">
        <div class="row" style="width:100%;">
          <el-input
            v-model="registNoForm.captcha"
            :placeholder="$t('message.captcha_plc')"
            @keyup.enter.native="save"
          ></el-input>
          <img
            :src="codeImg"
            @click="updateCode"
            style="margin-left:10px;cursor: pointer;height:48px;"
          />
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save">{{$t('message.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import i18n from "../../public/lang/index";
import { baseUrl, basePath } from "../api/axios";
import axios from "../api/axios";
import HzmbApplicationAPI from "../api/HzmbApplicationAPI";
import LoginAPI from "../api/LoginAPI";
export default {
  props: {
    visible: Boolean
  },
  data() {
    return {
      baseUrl: baseUrl,
      basePath: basePath,
      registNoForm: {},
      registNoRules: {
        registrationNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur"
          },
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur"
          }
        ],
        identificationNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur"
          }
        ],
        captcha: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur"
          }
        ]
      },
      codeImg: "",
      captchaId: ""
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.registNoForm = {};
        this.$refs["myForm"].resetFields();
      }
    }
  },
  computed: {
    serviceType() {
      return this.$store.state.serviceType;
    }
  },
  methods: {
    // 關閉
    handleClose() {
      this.$emit("close");
    },
    // 註冊編號儲存
    save() {
      this.$refs["myForm"].validate(valid => {
        if (valid) {
          // 為字符串每個length個字，添加一條橫線
          // const xreplace = (str, length) => {
          //   if (str.indexOf("-") != -1) {
          //     return str;
          //   }
          //   // str = str.replace(/-/g, "");
          //   var re = new RegExp("[a-zA-Z]{1,2}|[0-9]{1," + length + "}", "g");
          //   var ma = str.match(re);
          //   console.log(ma);
          //   return ma.join("-");
          // };
          let serviceType = this.serviceType;
          // 貨車預約處理
          if(this.$route.name === 'BookingVerification') {
            serviceType = "HZMB_H_BOOKING";
          }
          const registrationNo = this.registNoForm.registrationNo;
          const identificationNo = this.registNoForm.identificationNo;
          const captcha = this.registNoForm.captcha;
          HzmbApplicationAPI.vehicle(
            serviceType,
            registrationNo.replace(/-/g, ""),
            identificationNo,
            captcha
          )
            .then(res => {
              if (res.success) {
                console.log("查詢車輛資料成功");
                // console.log("this.registNoForm", this.registNoForm);
                if (!["development", "meta"].includes(process.env.VUE_APP_ENV)) {
                  this.registNoForm.registrationNo = res.plateNo;
                }
                this.$emit("save", this.registNoForm);
              } else {
                console.log("查詢車輛資料失敗");
                this.$message({
                  type: "error",
                  message: res.errorMsgs
                    .map(item => {
                      return item[`text${this.$t('message.lans')}`];
                    })
                    .join("/n")
                });
                this.updateCode();
              }
            })
            .catch(err => {
              if (err.code == "CAPTCHA_NOT_FOUND") {
                this.$message({
                  type: "error",
                  message: this.$t("message.ErrorMessage.CAPTCHA_NOT_FOUND")
                });
              } else if (err.code == "CAPTCHA_VERIFY_FAILED") {
                this.$message({
                  type: "error",
                  message: this.$t("message.ErrorMessage.CAPTCHA_VERIFY_FAILED")
                });
              } else if (err.code == "CAPTCHA_HAS_EXPIRED") {
                this.$message({
                  type: "error",
                  message: this.$t("message.ErrorMessage.CAPTCHA_HAS_EXPIRED")
                });
              } else {
                this.$error(err);
              }
              this.updateCode();
            });
        } else {
          return;
        }
      });
    },
    updateCode() {
      let _this = this;
      LoginAPI.checkVehicle()
        .then(res => {
          let codeImg =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
          _this.codeImg = codeImg;
        })
        .catch(err => {
          _this.$error(err);
        });
    }
  },
  created() {
    this.updateCode();
  }
};
</script>

<style lang="scss" scoped>
</style>